/**
 * @desc 远程接口地址和本地mock地址映射表
 * key：接口地址
 * value：本地地址
 */
import proposal from './proposal'
import sale from './sale'
import customer from './customer'
import my from './my'
import product from './product'
import serve from './serve'
import common from './common'
const mockBaseUrl = 'http://rap2api.taobao.org/app/mock'

let baseObj = {
  '/user/login': mockBaseUrl + '/223948/login',
  '/user/info': mockBaseUrl + '/223948/info',
  '/user/logout': mockBaseUrl + '/223948/logout'
}
Object.assign(baseObj, proposal, sale, customer, my, product, serve, common)

export default baseObj
